import React, {
  InputHTMLAttributes,
  forwardRef,
} from 'react';
import './InputCustom.scss';

type InputMode = 'default' | 'number' | 'string';

export interface InputCustomProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'type'> {
  id?: string;
  label?: string;
  mode?: InputMode;
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
}

const InputCustom = forwardRef<HTMLInputElement, InputCustomProps>(
  (
    {
      id,
      label,
      mode = 'default',
      value,
      onChange,
      error = false,
      disabled = false,
      className = '',
      placeholder,
      ...rest
    },
    ref
  ) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      let next = e.target.value;
      if (mode === 'number') {
        next = next.replace(/[^0-9.\-]/g, '');
      } else if (mode === 'string') {
        next = next.replace(/[0-9]/g, '');
      }
      onChange(next);
    };

    return (
      <div className={`settings-input-wrapper ${className}`}>
        {label && (
          <label htmlFor={id} className="settings-input-label">
            {label}
          </label>
        )}

        <div
          className={`
            settings-input-container
            ${error ? 'error' : ''}
            ${disabled ? 'disabled' : ''}
          `}
        >
          <input
            id={id}
            ref={ref}
            type="text"
            value={value}
            onChange={handleChange}
            disabled={disabled}
            placeholder={placeholder}
            onKeyDown={(e) => e.stopPropagation()}
            onKeyUp={(e) => e.stopPropagation()}
            className="settings-input"
            {...rest}
          />
        </div>
      </div>
    );
  }
);

export default InputCustom;
